import React from 'react';
import { Menu, MenuItem } from '@apply/components';

export const MenuDemo: React.FC<{}> = ({}) => {
    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Menu</li>
            <br />
            <Menu>
                <MenuItem
                    active={true}
                    hint='BFI Apply Home Page'
                    url='/home'
                >
                    Home
                </MenuItem>
                <MenuItem url='/businessandpeople'>Business & People</MenuItem>
                <MenuItem url='/experience'>Experience</MenuItem>
            </Menu>
        </div>
    );
};
